/* eslint-disable react-hooks/exhaustive-deps */
import {useQuery} from "@tanstack/react-query"
import {Row, Col} from "antd"
import CircularSpin from "components/CircularSpin"
import {CustomFieldInfo} from "components/CustomFieldInfo"
import {get} from "lodash"
import {useEffect} from "react"
import {fieldsService} from "services"
import {Settings} from "types/settings"

export function DepartmentCustomFields({
    module,
    userId,
    profileId,
    isFullDisplay,
    customFieldData,
    setCustomFieldData,
    onChange
}: {
    module: Settings.CustomFieldModule
    userId: number
    profileId: number
    isFullDisplay: boolean
    customFieldData: any
    setCustomFieldData: (value: any) => void
    onChange: (customFieldId, value: any) => void
}) {
    const {
        data: customFields,
        isLoading,
        isSuccess
    } = useQuery(["module-active-custom-fields", module], () =>
        fieldsService.getCustomFields({
            filter: {modules: [module], isActive: true},
            range: {page: 1, pageSize: 1000}
        })
    )
    const {
        data: customFieldsForProfile,
        isFetching: isLoadingCustomFieldsForProfile,
        isSuccess: isSuccessCustomFieldsForProfile
    } = useQuery(["student-module-custom-fields-for-profile", userId, profileId, module], () =>
        fieldsService.getCustomFieldsForProfile({
            filter: {userIds: [userId], profileIds: [profileId], modules: [module]}
        })
    )

    useEffect(() => {
        if (isSuccess && isSuccessCustomFieldsForProfile && customFields && customFieldsForProfile) {
            const newFieldData = {}
            customFields.data.forEach((field) => {
                const fieldData = customFieldsForProfile.find((item) => item.customFieldId === field.customFieldId)
                if (fieldData) {
                    newFieldData[field.customFieldId] = fieldData.value
                }
            })
            setCustomFieldData({...newFieldData})
        }
    }, [isSuccess, isSuccessCustomFieldsForProfile, customFields, customFieldsForProfile])

    if (isLoading || isLoadingCustomFieldsForProfile) {
        return <CircularSpin size="small" />
    }

    return (
        <Row gutter={[24, 24]}>
            {customFields.data.map((customField) => (
                <Col key={customField.customFieldId} span={isFullDisplay ? 8 : 24}>
                    <CustomFieldInfo
                        type={customField.fieldType}
                        label={customField.label}
                        value={get(customFieldData, [customField.customFieldId], null)}
                        onChange={(value) => onChange(customField.customFieldId, value)}
                    />
                </Col>
            ))}
        </Row>
    )
}
